<template>
    <v-dialog :fullscreen="isMobile" v-model="dialog" transition="dialog-bottom-transition" max-width="500" @click:outside="hide">
        <v-card v-if="exercise" tile flat>
            <v-app-bar color="white" flat class="kimsa-elevation">
                <v-row align="center" no-gutters>
                    <v-col cols="10" class="app-title text-truncate">
                        {{ $t('exercises.description') }}
                    </v-col>
                    <v-col cols="2" align="right">
                        <v-btn color="secondary" icon @click="hide">
                            <v-icon>$close</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-app-bar>

            <v-container>

                <v-row>
                    <!-- CATEGORIES & TYPES -->
                    <v-col cols="12" class="text-center">
                        <v-chip
                            v-for="category in exercise.categories"
                            :key="category"
                            outlined label
                            class="mr-1 mb-1"
                            small color="#333333"
                        >
                            {{ category }}
                        </v-chip>
                        <v-chip
                            v-for="type in exercise.types"
                            :key="type"
                            outlined label
                            class="mr-1 mb-1"
                            small color="#333333"
                        >
                            {{ type }}
                        </v-chip>
                    </v-col>
                    <!-- NAME -->
                    <v-col cols="12" class="name-exercise py-0">
                        {{ exercise.name }}
                    </v-col>
                    <!-- VIDEO PLAYER -->
                    <v-col cols="12">
                        <video-player
                            v-if="video"
                            ref="videoPlayer"
                            :options="playerOptions"
                        />
                        <v-img
                            v-else eager contain
                            :lazy-src="imgPlaceholder"
                            :src="exerciseImg"
                            class="exercise-img"
                        />
                    </v-col>
                    <!-- DESCRIPTION EXERCISE -->
                    <v-col v-if="exercise.description" class="exercise-description">
                        {{ exercise.description }}
                    </v-col>
                    <!-- COMMENTARY EXERCISE -->
                    <v-col cols="12" v-if="exercise.commentary">
                        <v-alert type="info" color="accent" outlined>
                            <b>{{ $t('exercises.comment_of_coach') }}:</b> {{ assignedExercise.commentary }}
                        </v-alert>
                    </v-col>
                </v-row>

            </v-container>

        </v-card>
    </v-dialog>
</template>

<script>

import {mapState, mapMutations, mapActions} from 'vuex'
import VideoPlayer from "@/components/common/VideoPlayer";

export default {
    components: {VideoPlayer},
    props: {
        isThirdDialog: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            dialog: false,
            exercise: null,
            playerOptions: {
                fluid: true,
                language: 'es',
                controls: true,
                autoplay: false,
                poster: null,
                sources: [{
                    type: 'application/x-mpegURL',
                    src: null,
                }],
            },
        }
    },
    computed: {
        ...mapState(['dialogActive', 'equipment', 'thirdDialogActive']),
        exerciseImg(vm = this) {
            return vm.exercise?.img || vm.exercise?.video?.thumb || vm.imgPlaceholder
        },
        video(vm = this) {
            if (!vm.exercise) return null
            const {video} = vm.exercise
            if (!video || !video.ready) return null
            vm.playerOptions.sources[0].src = video.url || null
            return video
        },
    },
    async mounted() {
        let vm = this
        if (vm.equipment.length === 0) await vm.bindEquipment()
    },
    methods: {
        ...mapMutations(['setDialogActive', 'setThirdDialogActive']),
        ...mapActions(['bindEquipment']),
        show() {
            const vm = this
            vm.dialog = true
            vm.isThirdDialog ? vm.setThirdDialogActive(true) : vm.setDialogActive(true)
        },
        hide() {
            const vm = this
            vm.dialog = false
            vm.isThirdDialog ? vm.setThirdDialogActive(false) : vm.setDialogActive(false)
            vm.reset()
        },
        reset() {
            const vm = this
            vm.exercise = null
        },
        setExercise(exercise) {
            const vm = this
            vm.exercise = exercise
        },
        equipImg(equip) {
            let vm = this
            return vm.equipment?.find(el => el.name === equip)?.src || vm.imgPlaceholder
        },
    },
    watch: {
        dialogActive(val) {
            if (!val) this.hide()
        },
        thirdDialogActive(val) {
            if (!val) this.hide()
        }
    }
}

</script>

<style scoped>

.app-title {
    font-size: 20px;
    line-height: 28px;
}

.name-exercise {
    font-size: 20px;
    line-height: 24px;
    font-weight: bold;
    color: #333333;
}

.exercise-img {
    border-radius: 8px;
}

.exercise-description {
    font-size: 12px;
    line-height: 16px;
    color: #666666;
    text-align: center;
}

</style>